import { RootState } from '../configureStore';
import { SubscriptionContract } from '../../contracts/subscription';

export const selectSubscriptions = (state: RootState): SubscriptionContract[] => {
    const subs = state.Subscriptions.subscriptions;
    return subs.ids.map(id => subs.byId[id]);
};

export const selectSubscriptionById = (state: RootState, id: string): SubscriptionContract | undefined => {
    return state.Subscriptions.subscriptions.byId[id];
};

export const selectProducts = (state: RootState) => {
    return state.Subscriptions.products;
};

export const selectLoading = (state: RootState) => {
    return state.Subscriptions.loading;
};

export const selectError = (state: RootState) => {
    return state.Subscriptions.error;
};

export const hasSubscriptions = (state: RootState) => {
    return state.Subscriptions.subscriptions.ids.length > 0;
};
